<script setup lang="ts">
import { Button } from '~~/src/components/ui/button'

const user = useUser()
const router = useRouter()

function handleLoginClick() {
  if (!user.value)
    return router.push(useGetLoginURL())
}
</script>

<template>
  <div class="flex flex-col w-full gap-3 items-center justify-center h-full p-8 text-center">
    <p class="text-softBlack font-700">
      Please log in to access your library and save your prompts.
    </p>
    <Button variant="snack-cta" class="w-full max-w-xs" @click="handleLoginClick">
      Log in
    </Button>
  </div>
</template>
